// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    clients: "Clients",
    pageDescription: "Configure client fields, tabs, and views",
    documentation: "Documentation",
    clientFields: "Client Fields",
    clientTabs: "Client Tabs",
    clientViews: "Client Views",
    costCategories: "Cost Categories",
    tabSettings: "Settings",
    loading: "Loading...",
  },
  nb_NO: {
    settings: "Innstillinger",
    clients: "Kunder",
    pageDescription: "Konfigurer kundefelt, faner og visninger",
    documentation: "Dokumentasjon",
    clientFields: "Kundefelt",
    clientTabs: "Kundefaner",
    clientViews: "Kundevisninger",
    costCategories: "Kostnadskategorier",
    tabSettings: "Innstillinger",
    loading: "Laster...",
  },
} as const;
